import { Checkbox, Popconfirm } from "antd";
import { ReactElement, useState } from "react";
import { useDispatch } from "react-redux";
import { getWarningConfirmation } from "src/common/data/warning-confirmation-messages";
import { WarningOmissionsActions } from "./reducer";
import "./index.scss";

export default function WarningConfirmation({
  children,
  onConfirm,
  warningId,
  okText,
  getPopupContainer,
  placement,
}): ReactElement {
  const dispatch = useDispatch();

  const [toIgnoreWarningPermanently, setToIgnoreWarningPermanently] = useState(false);
  const popupContainer = getPopupContainer ?? (() => document.body);

  return (
    <Popconfirm
      title={() => {
        return (
          <div>
            <div className="message">{getWarningConfirmation(warningId).message}</div>
            <div className="do-not-show-again">
              <Checkbox
                onChange={(event) => {
                  setToIgnoreWarningPermanently(event.target.checked);
                }}
              />
              Do not show this message again
            </div>
          </div>
        );
      }}
      icon={() => {
        return <div></div>;
      }}
      onConfirm={() => {
        if (toIgnoreWarningPermanently) {
          dispatch(WarningOmissionsActions.omitWarning({ id: warningId }));
        }
        onConfirm();
      }}
      okText={okText ?? "OK"}
      destroyTooltipOnHide={true}
      overlayClassName="warning-popup-confirmation"
      getPopupContainer={popupContainer}
      getTooltipContainer={popupContainer}
      placement={placement??"top"}
    >
      {children}
    </Popconfirm>
  );
}
